import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      token: null,
      user: null,
      isAuth: false,
      campings: [],
      camping: {},
      users: [],
      packLevel: 0,
      parameters: {
        // 0 -> tutto
        // 1 -> solo unità (tipologie)
        // 2 -> solo unità e persone
        // 3 -> solo servizi
        scontoSoloSuUnita: 0,
      },
    };
  },
  mutations,
  actions,
  getters,
};
